"use client";
import { useMouseMovement } from "@/app/[lang]/MouseMovementContext";
import React from "react";

const ShelveMonthlyPromotionLoader = ({
    children,
    productGroupData,
}: {
    children?: React.ReactNode;
    productGroupData: any;
}) => {
    const { hasMouseMoved } = useMouseMovement();

    return hasMouseMoved ? (
        children
    ) : (
        <section>
            {(productGroupData && productGroupData.productGroupItem && productGroupData.productGroupItem.length > 0) &&
                productGroupData.productGroupItem.map((item: any, index: number) => (
                    (item && item.productList && item.productList.length > 0) && (
                        item.productList.map((product: any) => (
                            (product && product.variantData) && (
                                <React.Fragment key={index}>
                                    <img alt={product.variantData.id} /> <br />
                                    {product.handle} <br />
                                    price {product.variantData.priceFull} <br />
                                </React.Fragment>
                            )
                        ))
                    )
                ))
            }
        </section>
    );
};

export default ShelveMonthlyPromotionLoader;
